import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { UserAction } from '../../store/actions';

class ChangePassword extends PureComponent {
  static propTypes = {
    changePassword: PropTypes.func,
    userId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
  }

  getInitialState() {
    return {
      password: '',
      password_confirmation: '',
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.changePassword(this.props.userId, this.state);
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Change Password User</h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="password">Password</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        id="password"
                        name="password"
                        onChange={this.onChange}
                        placeholder="Password"
                        type="password"
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-lock"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group col">
                    <label htmlFor="password_confirmation">
                      Confirm Password
                    </label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        id="password_confirmation"
                        name="password_confirmation"
                        onChange={this.onChange}
                        placeholder="Confirm Password"
                        type="password"
                      />
                      <div className="input-group-append">
                        <div className="input-group-text">
                          <span className="fas fa-lock"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Change
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (_, props) => ({
  userId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  changePassword: (id, data) => dispatch(UserAction.changePassword(id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
